import Api from '../../helpers/api';
import Locations from '../../helpers/locations';
import Constants from './PatientDetailsConstant';

export const getProfileDetails = (token) => {
  
    return function (dispatch) {

        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.GET_PROFILE_DATA_SUCCESS,
                payload: response.profile
            });
        };

        const errorCall = (errorResponse) => {
            dispatch({
                type: Constants.ACTIONS.GET_PROFILE_DATA_FAILED,
                payload: errorResponse
            });
        }

        Api.doGet(Locations.PatientDetails, {}, successCall, errorCall,token);
    }
}

export default {
    getProfileDetails
}